import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';

// The width ceiling for a learner-option pill. A fixed value (rather than a
// percentage) so the same wrap point applies whether the pill is measured
// against the wide student-runtime column or the ~324px flow-editor node, and
// so the static card and the live editor render an option identically. Used by
// both ConversationOptionButton and the flow editor's editable option pill.
export const OPTION_PILL_MAX_W = '15rem';

// -- ConversationOptionButton --------------------------------------------------
// A single learner-choice button, shared between the student runtime and the
// admin previews so its appearance can't drift. Presentational only: callers own
// the list rendering, animation and selection wiring. Right-aligned like a
// learner action; hugs short labels and wraps long ones at OPTION_PILL_MAX_W
// (like ConversationReplyBubble) so it never stretches or squashes.
export function ConversationOptionButton({
  onClick,
  children,
  isRtl = false,
}: {
  onClick: () => void;
  children: ReactNode;
  isRtl?: boolean;
}) {
  return (
    <Box
      as="button"
      cursor="pointer"
      alignSelf="flex-end"
      onClick={onClick}
      height="auto"
      textAlign={isRtl ? 'right' : 'left'}
      dir={isRtl ? 'rtl' : undefined}
      w="fit-content"
      maxW={OPTION_PILL_MAX_W}
      py="1"
      px="3"
      whiteSpace="normal"
      wordBreak="break-word"
      border="1px"
      borderColor="brand.600"
      fontSize="md"
      borderRadius="2xl"
      color="brand.600"
      fontWeight="semibold"
      backgroundColor="transparent"
      _hover={{ backgroundColor: 'brand.50' }}
    >
      {children}
    </Box>
  );
}
